<div class="container d-flex flex-column align-items-center justify-content-center min-vh-100">

  <a routerLink="/"><img src="https://get.hubbleapp.ai/images/hubble-logo.svg" alt="Hubble Logo" style="max-width: 200px; margin-bottom: 3rem;"></a>

  <div class="card p-4 shadow" style="max-width: 400px; width: 100%;">
    <h3 class="mb-4 text-center">Sign Up</h3>
    <form (ngSubmit)="signUp()">
      <div class="mb-3">
        <label for="email" class="form-label">Email</label>
        <input [(ngModel)]="email" name="email" type="email" class="form-control" id="email" required />
      </div>
      <div class="mb-3">
        <label for="password" class="form-label">Password</label>
        <input [(ngModel)]="password" name="password" type="password" class="form-control" id="password" required />
      </div>
      <button type="submit" class="btn btn-primary w-100">Sign Up</button>
      <div *ngIf="error" class="alert alert-danger mt-3">{{ error }}</div>
    </form>
    <p class="mt-3 mb-0 text-center">Already have an account? <a routerLink="/signin">Sign In</a></p>
  </div>
</div>